<template>
  <div>
    <LeftSidebar
      :visible="visible"
      baseClass="edit-user-wrapper"
      :title="$lang.whats_new_history_add"
      :hasHeaderRightIcon="false"
    >
      <template>
        <WhatsNewForm
          ref="whatsNewFormReference"
          :visible="visible"
          @submit="save"
        />
      </template>
      <template #footer>
        <Button
          variant="filled-complementary"
          :text="$lang.cancel"
          class="mobile-width-percent-100 tablet-width-percent-100"
          contentClass="justify-content-center tablet-width-percent-100"
          @click="close"
        />
        <Button
          v-if="checkPermission(permissions, ['admin', 'edit'])"
          variant="primary"
          :text="$lang.submitButton"
          class="mobile-width-percent-100 tablet-width-percent-100"
          contentClass="justify-content-center tablet-width-percent-100"
          :loading="loading"
          @click="submit"
        />
      </template>
    </LeftSidebar>
  </div>
</template>

<script>
import LeftSidebar from "@/components/re-design/sidebar/LeftSidebar.vue";
import WhatsNewForm from "../forms/WhatsNewForm.vue";
import { Button } from "@/components/re-design/forms";
import { addWhatsNew } from "@/modules/profile/services";
import { checkPermission, generateError, toastAlert } from "@/shared/utils";
import { ref, toRefs } from "vue";

export default {
  components: {
    LeftSidebar,
    WhatsNewForm,
    Button,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    permissions: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    // generate props data
    const { visible, permissions } = toRefs(props);

    // reference to whats new form
    const whatsNewFormReference = ref(null);

    // data
    const loading = ref(false);

    // methods
    const close = () => emit("close");
    const reload = () => emit("reload");
    const submit = () => {
      whatsNewFormReference.value.submit();
    };
    const save = async (payload) => {
      try {
        loading.value = true;
        const { versionId, changeTypeId, taskNumber, description } = payload;
        const response = await addWhatsNew(
          versionId,
          changeTypeId,
          taskNumber,
          description
        );
        const { message } = response;
        toastAlert(message);
        close();
        reload();
      } catch (error) {
        generateError(error);
      } finally {
        loading.value = false;
      }
    };

    return {
      visible,
      permissions,
      whatsNewFormReference,
      loading,
      close,
      reload,
      submit,
      save,
      checkPermission,
    };
  },
};
</script>
